export default function CompanyCard({ image }) {
  return (
    <div className="flex justify-center border-2 border-gray-300 px-10 py-8 w-60 h-28">
      <img src={image} alt={"temp"} style={{ objectFit: "contain" }} />
    </div>
  );
}
